import { beforeReady } from './lib/before-ready'
import { addiesaasBeforeReady } from 'utils/vue/lib/utils'

addiesaasBeforeReady(beforeReady)

export default {}
